/*
 *
 * UserDefinedConfigProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import React from 'react';
import { IntlProvider } from 'react-intl';
import { useUILanguage } from '../UILanguage';

type UserDefinedConfigProviderProps = {
  messages: Record<string, Record<string, string>>;
  children: React.ReactNode;
};

export const UserDefinedConfigProvider = ({
  messages,
  children,
}: UserDefinedConfigProviderProps) => {
  const { locale } = useUILanguage();
  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <>{children}</>
    </IntlProvider>
  );
};

export default UserDefinedConfigProvider;
